export default __webpack_public_path__ + "static/media/amazon-clone.880d64e5.png";